import {
  Box,
  FlexAnchor,
  FlexAnchorProps,
  Icon,
  IconProperty,
  smBumps,
  Typo,
  useModal,
} from '@wrisk/ui-components'
import React, { useCallback } from 'react'

import {
  tCovers,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { HelpLinkIFrame } from '../links/HelpLinkIFrame'

interface IncludedCoverItemProps extends Omit<FlexAnchorProps, 'ref'> {
  code: string
  iconSize?: IconProperty
  contentBaseUrl: string
}

export const IncludedCoverItem: React.FC<IncludedCoverItemProps> = ({
  code,
  contentBaseUrl,
  typoSize,
  iconSize,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const modal = useModal()

  const onClick = useCallback(() => {
    modal.show({
      content: <HelpLinkIFrame src={`${contentBaseUrl}/${code}.html`} />,
      variant: 'iframe',
    })
  }, [contentBaseUrl, code, modal])

  return (
    <FlexAnchor
      variant='highlight'
      flexWrap='nowrap'
      py={3}
      px={smBumps}
      onClick={onClick}
      {...props}
    >
      <Box mr={2} display='flex' flexDirection='row' flexWrap='nowrap'>
        <Icon icon='tick' mr={smBumps} size={iconSize ?? 'medium'} />
        <Typo wordWrap='break-word' typoSize={typoSize}>
          {t(tCovers(code, 'name'))}
        </Typo>
      </Box>
      <Icon icon='info' size='tiny' />
    </FlexAnchor>
  )
}
